
import React from 'react';

interface UserStatusProps {
  currentUser: any;
}

const UserStatus: React.FC<UserStatusProps> = ({ currentUser }) => {
  return (
    <div className="text-xs text-center text-gray-500 bg-gray-50 p-2 rounded">
      👤 {currentUser ? `Connecté: ${currentUser.email}` : 'Non connecté'}
      {!currentUser && (
        <div className="text-red-600 mt-1">
          ⚠️ Connexion requise pour travailler
        </div>
      )}
    </div>
  );
};

export default UserStatus;
